import { useContext } from "react";
import ReactDOM from "react-dom";
import BlockchainContext from "../store/BlockchainContext";
import DepositModalContext from "../store/DepositModalContext";
import { numberWithCommas } from "../utils/util";
import $ from "jquery";
import { parse } from "dotenv";

const DashboardSection = () => {
  const {
    handleWithdraw,
    handleInsurance,
    usdPrice,
    historyTotalInfo,
    userInvitedInfo,
    harvestValue,
    userTransactions,
    availableValue,
    startTime,
    getInsuranceInfo,
  } = useContext(BlockchainContext);
  const { showModal } = useContext(DepositModalContext);

  $(".arrow-btn").click(function () {
    if ($(".user-transation-holder").hasClass("block-hidden")) {
      $(".user-transation-holder").removeClass("block-hidden").show();
    } else {
      $(".user-transation-holder").addClass("block-hidden").hide();
    }
  });

  function epochToJsDate(ts) {
    // ts = epoch timestamp
    // returns date obj
    return new Date(ts * 1000);
  }

  var dateString = startTime;
  var startTime_2 = startTime;
  var startDate = epochToJsDate(startTime_2);

  var numberOfDaysToAdd = 14;
  var result = startDate.setDate(startDate.getDate() + numberOfDaysToAdd);

  var stop_date = new Date(result).toGMTString();

  function isDateInFuture(date) {
    return date > Date.now();
  }

  if (isDateInFuture(new Date(stop_date))) {
    var insurance = 1;
  } else {
    insurance = 0;
  }

  if (startTime) {
    console.log("Now = " + result);
    console.log("Insurance = " + insurance);
    console.log("Start Time = " + JSON.stringify(startTime));
    console.log("Last Date  = " + stop_date);
  }

  var insuranceStatus = parseInt(getInsuranceInfo);

  // Calculator
  $("input#y_amount").keyup(function () {
    var amount = $(this).val();
    var amount = parseFloat(amount);
    $("#y_investment span").text((amount * 100) / 100 + " MATIC");

    var d_reward = (amount * 0.7) / 100;

    var y6_reward = d_reward * 6 * 30;
    var y6d_reward = ((y6_reward + amount) * 0.7) / 100;

    var y12_reward = y6d_reward * 6 * 30;
    var y12d_reward = ((y12_reward + amount) * 0.7) / 100;

    var y18_reward = y12d_reward * 6 * 30;
    var y18d_reward = ((y18_reward + amount) * 0.7) / 100;

    var y24_reward = y18d_reward * 6 * 30;

    $("#y6_reward span").text(y6_reward.toFixed(3) + " MATIC");
    $("#y12_reward span").text(y12_reward.toFixed(3) + " MATIC");
    $("#y18_reward span").text(y18_reward.toFixed(3) + " MATIC");
    $("#y24_reward span").text(y24_reward.toFixed(3) + " MATIC");
  });

  var _deposit = historyTotalInfo[0];
  var _t_withdraw = historyTotalInfo[1];
  var _harvest = harvestValue;
  var _ref = userInvitedInfo[1];

  var _new = parseFloat(_deposit) * 2.7;
  var _dec = parseFloat(_t_withdraw) + parseFloat(_harvest);

  var new_amount = _new - _dec;
  var remaing = availableValue - parseFloat(_harvest);

  //var _remaingEarning = (historyTotalInfo[0]*2.7)-(historyTotalInfo[1]-harvestValue);
  var remaingEarning = remaing;

  // Modal
  $("#clcBtn").click(function () {
    $("#calculateModal").show().addClass("show");
  });
  $(".close_btn").click(function () {
    $("#calculateModal").hide().removeClass("show");
  });

  return (
    <>
      <section className="panel_section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-12">
              <div className="panel deposit mb-5">
                <h3>Dashboard</h3>
                <div className="row">
                  <div className="col-md-2 col-12">
                    <div className="roi_box vertical-center">
                      <h5>
                        DAILY ROI <br />
                        0.7%
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-2 col-6 vertical-center">
                    <div className="info-col">
                      <h5>{numberWithCommas(historyTotalInfo[0], 5)} MATIC</h5>
                      <span className="small">
                        ~ ${numberWithCommas(historyTotalInfo[0] * usdPrice, 2)}
                      </span>
                      <h6 className="mb-0">Total Deposit</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-6 vertical-center">
                    <div className="info-col">
                      <h5>{numberWithCommas(remaingEarning, 5)} MATIC</h5>
                      <span className="small">
                        ~ ${numberWithCommas(remaingEarning * usdPrice, 2)}
                      </span>
                      <h6 className="mb-0">Remaining Earnings</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-6 vertical-center">
                    <div className="info-col">
                      <h5>{numberWithCommas(historyTotalInfo[1], 5)} MATIC</h5>
                      <span className="small">
                        ~ ${numberWithCommas(historyTotalInfo[1] * usdPrice, 2)}
                      </span>
                      <h6 className="mb-0">Total Withdraw</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-6 vertical-center">
                    <div className="info-col">
                      <h5>{numberWithCommas(harvestValue, 5)} MATIC</h5>
                      <span className="small">
                        ~ ${numberWithCommas(harvestValue * usdPrice, 2)}
                      </span>
                      <h6 className="mb-0">MATIC to Harvest</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-12">
                    <div className="button-col">
                      {(() => {
                        if (historyTotalInfo[0] == 0 || remaingEarning >= 0) {
                          return (
                            <button
                              className="w-100 mb-2 btn-sm btn btn-light"
                              onClick={() => showModal()}
                            >
                              <span>Deposit</span>
                            </button>
                          );
                        }
                        return null;
                      })()}
                      <button
                        className="w-100 mb-2 btn-sm btn btn-outline-light"
                        onClick={() => handleWithdraw()}
                      >
                        <span>Harvest</span>
                      </button>
                      <a
                        className="w-100 mb-2 btn-sm btn btn-outline-light"
                        id="clcBtn"
                      >
                        <span>Calculate Reward</span>
                      </a>
                    </div>
                  </div>
                  <div className="col-12 text-center">
                    <hr />
                    <button type="button" className="btn btn-link arrow-btn">
                      <span className="arrow-btn--txt">History</span>
                      <svg className="icon icon-arrow-down" viewBox="0 0 32 32">
                        <path d="M16 25.121c-0.573 0-1.147-0.219-1.584-0.656l-13.759-13.759c-0.875-0.875-0.875-2.294 0-3.169s2.294-0.875 3.169 0l12.174 12.175 12.174-12.175c0.875-0.875 2.294-0.875 3.169 0s0.876 2.294 0 3.169l-13.759 13.759c-0.437 0.437-1.011 0.656-1.584 0.656z"></path>
                      </svg>
                    </button>
                  </div>
                  <div
                    className="col-12 block-hidden user-transation-holder"
                    style={{ display: "none", width: "100%" }}
                  >
                    <div className="table-responsive">
                      <table className="table table-bordered text-center text-white">
                        <thead>
                          <tr>
                            <th>
                              <span className="small">Date</span>
                            </th>
                            <th>
                              <span className="small">Action</span>
                            </th>
                            <th>
                              <span className="small">Amount</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {userTransactions &&
                            userTransactions.map((tx, index) => (
                              <tr key={index}>
                                <td className="text-align-center">
                                  <span className="small">
                                    {tx.time[0]} - {tx.time[1]}
                                  </span>
                                </td>
                                <td className="text-align-center">
                                  <span className="small">{tx.action}</span>
                                </td>
                                <td className="text-align-center">
                                  <span className="small">
                                    {tx.amount} MATIC
                                  </span>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-12 col-12">
              {/* <div className="panel deposit mb-5">
                <h3>Insurance</h3>
                <div className="row">
                  <div className="col-md-2 col-12">
                    <div className="roi_box vertical-center">
                      <h5>
                        Insure with
                        <br />
                        10%
                      </h5>
                    </div>
                  </div>
                  <div className="col-md-2 col-12 vertical-center">
                    <div className="info-col">
                      <h5
                        className={
                          insuranceStatus === 0
                            ? "badge btn-sm bg-danger"
                            : "badge btn-sm bg-success"
                        }
                      >
                        {insuranceStatus === 0 ? "Passive" : "Active"}
                      </h5>
                      <h6 className="mb-0">Your Insurance Status</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-6 offset-md-1 vertical-center">
                    <div className="info-col">
                      <h5>{numberWithCommas(historyTotalInfo[0], 5)} MATIC</h5>
                      <span className="small">
                        ~ ${numberWithCommas(historyTotalInfo[0] * usdPrice, 2)}
                      </span>
                      <h6 className="mb-0">Your Total Investment</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-6 offset-md-1 vertical-center">
                    <div className="info-col">
                      <h5>
                        {numberWithCommas(historyTotalInfo[0] / 10, 6)} MATIC
                      </h5>
                      <span className="small">
                        ~ $
                        {numberWithCommas(
                          (historyTotalInfo[0] * usdPrice) / 10,
                          5
                        )}
                      </span>
                      <h6 className="mb-0">Insurance Fee</h6>
                    </div>
                  </div>
                  <div className="col-md-2 col-12 vertical-center">
                    <div className="button-col w-100">
                      <button
                        disabled={insurance === 0}
                        className="w-100 mb-2 btn-sm btn btn-light w-100"
                        onClick={() =>
                          handleInsurance(
                            numberWithCommas(historyTotalInfo[0] / 10, 6)
                          )
                        }
                      >
                        <span>Insurance</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>

        <div
          className="modal fade"
          id="calculateModal"
          tabindex="-1"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Calculate Reward
                </h5>
                <button
                  type="button"
                  className="btn-close close_btn"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <label>MATIC Amount</label>
                  <input
                    min="0.05"
                    max="100"
                    id="y_amount"
                    className="form-control mb-3"
                    placeholder="Amount"
                    type="number"
                  />
                  <p className="mb-1" id="y_investment">
                    Your Investment:{" "}
                    <span className="float-end">0.00 MATIC</span>
                  </p>
                  <hr />
                  <p className="mb-1" id="y6_reward">
                    6 Month Reward:{" "}
                    <span className="float-end">0.00 MATIC</span>
                  </p>
                  <p className="mb-1" id="y12_reward">
                    12 Month Reward:{" "}
                    <span className="float-end">0.00 MATIC</span>
                  </p>
                  <p className="mb-1" id="y18_reward">
                    18 Month Reward:{" "}
                    <span className="float-end">0.00 MATIC</span>
                  </p>
                  <p className="mb-1" id="y24_reward">
                    24 Month Reward:{" "}
                    <span className="float-end">0.00 MATIC</span>
                  </p>
                </form>
                <hr />
                <p className="text-center mb-0">
                  Note: Does not indicate net earnings. Rates may vary.
                </p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light close_btn"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DashboardSection;
